
import { metaIconSrc } from '@utils/tempStatusUtils'
import { size as themeSize } from '@styles/theme'
import styled from '@emotion/styled'

const Icon = styled.img`
  flex-shrink: 0;
  aspect-ratio: 1;
  object-fit: cover;
`

const TempStatusMetaIcon = ({ accessor, value, size=1.75, style={}, ...rest }) => {
  return (
    <Icon
      style={{ height: themeSize(size), width: themeSize(size), ...style }}
      src={metaIconSrc(accessor, value)}
      {...rest}
    />
  )
}

export { TempStatusMetaIcon }
